module.exports = __webpack_public_path__ + "static/flying_snake-f47fd7dd0a85e4fd56f5584f55e71fa8.jpeg";